export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          {/* Image */}
          <div className="w-full lg:w-2/5">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-100 border border-background-300/30">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20digital%20entertainment%20platform%20concept%2C%20abstract%20media%20streaming%20visualization%2C%20dark%20background%20with%20glowing%20warm%20crimson%20and%20gold%20light%20trails%2C%20technology%20and%20entertainment%20fusion%2C%20sleek%20minimalist%20design%2C%20professional%20corporate%20aesthetic&width=800&height=600&seq=about-platform-visual&orientation=landscape"
                alt="关于黑料不打烊平台"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-3/5">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">关于黑料</h2>
            <div className="mt-6 space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                黑料不打烊在线观看平台成立于2024年，是一个专注于娱乐八卦、热点话题、综艺影视等领域
                的内容聚合平台。我们致力于为用户提供最新、最快、最全的黑料在线视频观看体验，
                7×24小时不间断更新，真正做到"不打烊"。
              </p>
              <p>
                平台汇聚了黑料每日大赛、明星八卦追踪、网红动态速递、综艺精彩cut、影视吐槽合集等
                12大内容板块，每日更新超过200条新鲜视频内容。所有内容均可免费高清观看，
                无需注册、无需付费，打开即看。
              </p>
              <p>
                我们的编辑团队全天候监控全网热点，第一时间为用户呈现最具话题性的黑料内容。
                无论是热门事件的深度梳理，还是最新视频的快速上线，黑料不打烊都力求做到
                又快又全，让每一位用户都能在这里找到想看的内容。
              </p>
            </div>

            <div className="flex flex-wrap gap-4 mt-7">
              <div className="flex items-center gap-2 bg-background-100 border border-background-300/40 rounded-lg px-4 py-2.5">
                <i className="ri-vidicon-line text-primary-400 text-lg"></i>
                <span className="text-sm text-foreground-700 whitespace-nowrap">海量视频资源</span>
              </div>
              <div className="flex items-center gap-2 bg-background-100 border border-background-300/40 rounded-lg px-4 py-2.5">
                <i className="ri-timer-flash-line text-accent-400 text-lg"></i>
                <span className="text-sm text-foreground-700 whitespace-nowrap">实时热点追踪</span>
              </div>
              <div className="flex items-center gap-2 bg-background-100 border border-background-300/40 rounded-lg px-4 py-2.5">
                <i className="ri-shield-check-line text-primary-400 text-lg"></i>
                <span className="text-sm text-foreground-700 whitespace-nowrap">安全免费观看</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}